export const Get_All_Product = "Get_All_Product";
export const Get_All_Offers = "Get_All_Offers";
export const Get_Product_Details = "Get_Product_Details";
export const Get_Offers_Details = "Get_Offers_Details";

// post
export const Post_Login = "Post_Login";
export const Post_Product = "Post_Product";
export const Delete_Product = "Delete_Product";
export const Delete_Offer = "Delete_Offer";
export const Post_Offer = "Post_Offer";
